/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdditionalServiceGroupByWareIdRespVo } from './AdditionalServiceGroupByWareIdRespVo';
import {
    AdditionalServiceGroupByWareIdRespVoFromJSON,
    AdditionalServiceGroupByWareIdRespVoFromJSONTyped,
    AdditionalServiceGroupByWareIdRespVoToJSON,
    AdditionalServiceGroupByWareIdRespVoToJSONTyped,
} from './AdditionalServiceGroupByWareIdRespVo';

/**
 * 
 * @export
 * @interface ResponseListAdditionalServiceGroupByWareIdRespVo
 */
export interface ResponseListAdditionalServiceGroupByWareIdRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListAdditionalServiceGroupByWareIdRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListAdditionalServiceGroupByWareIdRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<AdditionalServiceGroupByWareIdRespVo>}
     * @memberof ResponseListAdditionalServiceGroupByWareIdRespVo
     */
    data?: Array<AdditionalServiceGroupByWareIdRespVo>;
}

/**
 * Check if a given object implements the ResponseListAdditionalServiceGroupByWareIdRespVo interface.
 */
export function instanceOfResponseListAdditionalServiceGroupByWareIdRespVo(value: object): value is ResponseListAdditionalServiceGroupByWareIdRespVo {
    return true;
}

export function ResponseListAdditionalServiceGroupByWareIdRespVoFromJSON(json: any): ResponseListAdditionalServiceGroupByWareIdRespVo {
    return ResponseListAdditionalServiceGroupByWareIdRespVoFromJSONTyped(json, false);
}

export function ResponseListAdditionalServiceGroupByWareIdRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListAdditionalServiceGroupByWareIdRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(AdditionalServiceGroupByWareIdRespVoFromJSON)),
    };
}

export function ResponseListAdditionalServiceGroupByWareIdRespVoToJSON(json: any): ResponseListAdditionalServiceGroupByWareIdRespVo {
    return ResponseListAdditionalServiceGroupByWareIdRespVoToJSONTyped(json, false);
}

export function ResponseListAdditionalServiceGroupByWareIdRespVoToJSONTyped(value?: ResponseListAdditionalServiceGroupByWareIdRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(AdditionalServiceGroupByWareIdRespVoToJSON)),
    };
}

